import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { EmployeeAuthService } from '../services/employee-auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const employeeAuthService = inject(EmployeeAuthService);
  const router = inject(Router);

  // Permitir acceso si:
  // 1. Está autenticado como owner directo
  // 2. O está autenticado como empleado que es owner
  if (authService.isAuthenticated() || (employeeAuthService.isAuthenticated() && employeeAuthService.isOwner())) {
    return true;
  }

  // Redirect to login with return url
  return router.createUrlTree(['/login'], { 
    queryParams: { returnUrl: state.url } 
  });
};
